import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

const BASE_CELL_WIDTH = 60;
const ERROR_CELL_WIDTH = 80;

export const renderHorizontalTable = (title, fields, intercardInfo) => (
  <TableContainer component={Paper} sx={{ mb: 2, borderBottom: '1px solid #ccc' }}>
    <Typography variant="subtitle1" sx={{ p: 2, fontWeight: 600 }}>
      {title}
    </Typography>
    <Table size="small" sx={{ border: '1px solid #ccc', tableLayout: 'fixed' }}>
      <TableHead>
        <TableRow>
          {fields.map(({ label, field }) => (
            <TableCell
              key={field || label}
              sx={{
                border: '1px solid #ccc',
                fontWeight: 600,
                textAlign: 'center',
                verticalAlign: 'middle',
                p: 1,
                width: label.toLowerCase().includes('error') ? ERROR_CELL_WIDTH : BASE_CELL_WIDTH,
              }}
              align="center"
            >
              {label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          {fields.map(({ field, isError, label }) => {
            const raw = intercardInfo?.[field];
            const content = raw !== null && raw !== undefined && raw !== '' ? String(raw) : '-';

            const textNode = (
              <Tooltip title={content} arrow>
                <Typography
                  component="span"
                  sx={{
                    display: 'block',
                    width: 165,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: isError ? '0.68rem' : '0.70rem',
                    fontWeight: 500,
                    lineHeight: 1.1,
                    m: 0,
                    p: 0,
                  }}
                >
                  {content}
                </Typography>
              </Tooltip>
            );

            const hasValue = content !== '-';

            return (
              <TableCell
                key={field || label}
                sx={{
                  border: '1px solid #ccc',
                  color: isError ? 'red' : 'inherit',
                  fontWeight: isError ? 600 : 'inherit',
                  backgroundColor: isError && hasValue ? '#fff5f5' : 'inherit',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
                style={{ padding: '8px' }}
                align="center"
              >
                {isError && hasValue ? textNode : content}
              </TableCell>
            );
          })}
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
);

const NayaxAccordion = ({ nayaxInfo }) => {
  const fields = [
    { label: 'Nayax Count Before Queue Start', field: 'nayax_count_before_queue_start' },
    { label: 'Nayax Count After Queue Finishes', field: 'nayax_count_after_queue_finishes' },
    { label: 'Nayax Rows Feed', field: 'nayax_rows_feed' },
    { label: 'Nayax Rows Staging', field: 'nayax_rows_staging' },
    { label: 'Nayax Rows Failed', field: 'nayax_rows_failed' },
    { label: 'Nayax Rows Success', field: 'nayax_rows_success' },
    { label: 'Nayax Rows Unmapped', field: 'nayax_rows_unmapped' },
    { label: 'Nayax Rows Inserted', field: 'nayax_rows_inserted' },
    { label: 'Nayax Rows Updated', field: 'nayax_rows_updated' },
    { label: 'Nayax Rows Deleted', field: 'nayax_rows_deleted' },
    { label: 'Nayax Rows Reinstated', field: 'nayax_rows_reinstated' },
    { label: 'Nayax Error Text', field: 'nayax_error_text', isError: true },
    { label: 'Nayax Error Detail', field: 'nayax_error_detail', isError: true },
  ];

  return renderHorizontalTable('Nayax Details', fields, nayaxInfo);
};

export default NayaxAccordion;
